module.exports = {"id":"199952","name":"Emre Çolak","rating":"79","photo":"./data/images/photos/1/199952.png","club":{"name":"Deportivo","logo":"./data/images/clubs/Deportivo.png"},"positions":["MOC","MD","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EmreColak0.json
// module id = 1248
// module chunks = 0